import { theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const RatingFilterContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const StarsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;

  ${theme.typography.labelRegular400}
`;

export const Stars = styled.div`
  display: flex;
  align-items: center;
  gap: 0.12rem;
`;
